import { TypographyOptions } from '@mui/material/styles/createTypography';

/**
 * MUI Typography Options
 */
export const typography: TypographyOptions = {
    fontFamily: ['Roboto', 'sans-serif'].join(','),
    h1: {
        fontSize: '4rem',
        fontWeight: 500,
    },
    h2: {
        fontSize: '3.5rem',
        fontWeight: 500,
    },
    h3: {
        fontSize: '3rem',
        fontWeight: 500,
    },
    h4: {
        fontSize: '2.5rem',
        fontWeight: 500,
    },
    h5: {
        fontSize: '2rem',
        fontWeight: 500,
    },
    h6: {
        fontSize: '1.5rem',
        fontWeight: 500,
    },
    subtitle1: {
        fontSize: '1.25rem',
        fontWeight: 400,
    },
    subtitle2: {
        fontSize: '1rem',
        fontWeight: 400,
    },
    body1: {
        fontSize: '1rem',
        fontWeight: 400,
    },
    body2: {
        fontSize: '0.875rem',
        fontWeight: 400,
    },
    body3: {
        fontSize: '0.625rem',
        fontWeight: 400,
    },
    button: {
        fontSize: '1rem',
        fontWeight: 500,
    },
    caption: {
        fontSize: '0.75rem',
        fontWeight: 400,
    },
    overline: {
        fontSize: '0.625rem',
        fontWeight: 400,
    },
};

declare module '@mui/material/styles' {
    interface TypographyVariants {
        body3: React.CSSProperties;
    }

    // allow configuration using `createTheme`
    interface TypographyVariantsOptions {
        body3?: React.CSSProperties;
    }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        body3: true;
    }
}
